import {
  ChevronLeft,
  ChevronRight,
  ChevronDown,
  createIcons,
  ArrowRight,
  Check,
  Menu,
  TrendingUp,
  TrendingDown,
  Mail,
  MapPin,
  Phone,
  CircleDollarSign,
  Clock,
  Calendar,
  UserRoundPen,
} from "lucide";

createIcons({
  icons: {
    ChevronLeft,
    ChevronRight,
    ChevronDown,
    ArrowRight,
    Check,
    Menu,
    TrendingUp,
    TrendingDown,
    Mail,
    MapPin,
    Phone,
    CircleDollarSign,
    Clock,
    Calendar,
    UserRoundPen,
  },
});
